import { useEffect } from 'react';
import { useUsageStore, type UsageStats } from '../store/usageStore';

export type { UsageStats };

export const useUsage = () => {
  const { usage, loading, error, fetchUsage } = useUsageStore();

  useEffect(() => {
    fetchUsage();
  }, [fetchUsage]);

  return { usage, loading, error, refetch: fetchUsage };
};
